import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useState } from 'react';
import { debounce } from 'throttle-debounce';
import { useApplicationContext } from '../../../ApplicationContext';
import { getVillageSuggests } from '../../../../services/getVillageSuggests';
export var useVillageSuggests = function useVillageSuggests() {
  var _ref;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetching = _useState2[0],
    setIsFetching = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    suggests = _useState4[0],
    setSuggests = _useState4[1];
  var _useApplicationContex = useApplicationContext(),
    httpApi = _useApplicationContex.httpApi,
    logger = _useApplicationContex.logger;
  var getSuggestions = useCallback(function (_x) {
    return (_ref = _ref || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name) {
      var suggestList;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!name || name.length < 3)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", setSuggests([]));
          case 2:
            setIsFetching(true);
            _context.next = 5;
            return getVillageSuggests({
              name: name
            }, {
              httpApi: httpApi,
              logger: logger
            });
          case 5:
            suggestList = _context.sent;
            setIsFetching(false);
            setSuggests(suggestList.map(function (item) {
              return {
                title: item.name,
                subtitle: item.address,
                value: item.id
              };
            }));
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))).apply(this, arguments);
  }, [httpApi, logger, setIsFetching]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var getGeoSuggestDebounced = useCallback(debounce(400, getSuggestions), [getSuggestions]);
  return {
    isFetching: isFetching,
    suggests: suggests,
    getSuggestions: getGeoSuggestDebounced
  };
};